export default __webpack_public_path__ + "static/media/197.c14105a4.jpg";